import React, { FC, ReactElement } from 'react'
import styles from './Skeleton.module.css'
import Skeleton from '@mui/material/Skeleton'
import classnames from 'classnames'

const CustomSkeleton: FC<{ className?: string }> = (props): ReactElement => {
	return (
		<Skeleton
			variant="rectangular"
			animation="wave"
			classes={{ rectangular: classnames({ [(props?.className as any)]: !!props?.className }, styles.root) }}
		/>
	)
}

export default CustomSkeleton
